import React from 'react';
import { setCurrentView } from 'core/utils';
import { ProductActivityViewStore } from 'modules/product/stores';
import { ProductActivityTemplate } from 'themes/modules/product/pages';

@setCurrentView(rootStore => new ProductActivityViewStore(rootStore), 'productActivityViewStore')
class ProductActivity extends React.Component {
	render() {
		return <ProductActivityTemplate {...this.props} actions={this.props.productActivityViewStore} />;
	}
}

export default ProductActivity;
